import type {
  APIBookingDraftBusServiceOption,
  APIBookingDraftCarRentalServiceOption,
  APIBookingDraftClothingServiceOption,
  APIBookingDraftGolfServiceOption,
  APIBookingDraftLuggageServiceOption,
  APIBookingDraftServiceCancellationInsuranceOption,
  APIBookingDraftSkiAncillaryServiceOption,
} from '@/scopes/checkout/infrastructure/api/types'

export enum ServiceTypeApi {
  ConditionalMessages = 'ConditionalMessagesComponent',
  BookingRedeemer = 'BookingRedeemer',
  ParticipantsBadge = 'ParticipantsBadge',
  ParticipantsForm = 'ParticipantsForm',
  SkiAncillaries = 'SkiAncillariesService',
  Luggage = 'LuggageService',
  CarRental = 'CarRentalService',
  CancellationInsurance = 'CancellationInsuranceComparisonTable',
  Generic = 'GenericService',
  Golf = 'GolfService',
  GenericPerUnitComponent = 'GenericPerUnitComponent',
  GenericPerParticipantSelection = 'GenericPerParticipantSelection',
  Preferences = 'AvailablePreferences',
  TermsAndConditions = 'TermsAndConditions',
}

export type ServiceRenderType = 'PerBooking' | 'PerParticipant' | 'PerRoom' | undefined

export enum ServiceRenderTypeEnum {
  PerBooking = 'PerBooking',
  PerParticipant = 'PerParticipant',
  PerRoom = 'PerRoom',
}

export interface APIBookingDraftService {
  aName: string
  options: (
    | APIBookingDraftServiceOption
    | APIBookingDraftLuggageServiceOption
    | APIBookingDraftServiceCancellationInsuranceOption
    | APIBookingDraftBusServiceOption
    | APIBookingDraftCarRentalServiceOption
    | APIBookingDraftSkiAncillaryServiceOption
    | APIBookingDraftClothingServiceOption
    | APIBookingDraftGolfServiceOption
  )[]
  warnings?: APIBookingDraftServiceWarning[]
  isPricePerPerson?: boolean
  renderType?: ServiceRenderType
}

export interface APIBookingDraftServiceOption {
  displayText: string
  bestValueText?: string
  uniqueId?: string
  code: string
  price: number
  percentage?: string
  isSelected: boolean
  isIncluded?: boolean
  appliesToParticipants: number[]
  assignedParticipants: number[]
  prices?: APIBookingDraftServiceOptionParticipantPrice[]
}

export interface APIBookingDraftServiceOptionParticipantPrice {
  participantIds: number[]
  price: number
}

export interface APIBookingDraftServiceWarning {
  title?: string
  message?: string
  type?: string
}

export * from './bridge'
export * from './bus'
export * from './cancellationInsurance'
export * from './carRental'
export * from './clothing'
export * from './dinnerVouchers'
export * from './golf'
export * from './luggage'
export * from './ski'
